import {
    GET_QA_TEMPLATES, INSPECTION_DASHBOARD_DOCUMENT,

} from '../type'

const initialState = {
    qaTemplate: [],
    loading: true,
    inspectionDashboardDocument: [1, 2, 3],
}

export default function qaTemplateReducer(state = initialState, action) {
    switch (action.type) {

        case GET_QA_TEMPLATES:
            return {
                ...state,
                qaTemplate: action.payload,
                loading: false

            }

        case INSPECTION_DASHBOARD_DOCUMENT:
            return {
                ...state,
                qaTemplate: action.payload,
                loading: false

            }
        default: return state
    }

}
